import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { SignUpStatus } from '@fitness-force/enum';

import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'signup-status',
  templateUrl: './signup-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class SignUpStatusComponent {
  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null);

  getStatusValue(value: string) {
    switch (value) {
      case 'Created':
        return 'Waiver & Payment Link Sent';
      case 'Open':
        return 'Waiver & Payment Link Sent';
      case 'WaiverDone':
        return 'Waiver Signing';
      case 'MandatoryInformationDone':
        return 'Personal Details';
      case 'PendingForMandatoryAction':
        return 'Personal Details';
      case 'AwaitingPayment':
        return 'Awaiting Payment';
      case 'SignUpSuccessfull':
        return 'Sign up done Successfully';
      case 'SignUpFailed':
        return 'Dont Show this data';
      case 'SignUpExpired':
        return 'Dont Show this data';
      case 'Void':
        return 'Dont Show this data';
      default:
        return ""
    }
  }
}
